/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const getApiProjectprioritiesIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
});

/**
 * @description OK
 */
export const getApiProjectprioritiesId200Schema = z.object({
  id: z.coerce.number().int().optional(),
  name: z.coerce.string(),
});

export const getApiProjectprioritiesIdQueryResponseSchema = z.lazy(
  () => getApiProjectprioritiesId200Schema,
);
